import { Content } from 'src/app/models/content.model';

export const TOOLS_CONTENT: Content = new Content({
   idContent: 'ed50542c6ca94fc909e8391bd59c69fc',
   order: 1,
   title: 'Herramientas de apoyo',
   content: `
   <!-- Diagnóstico de autoevaluación (Apéndice Normativo C). -->
   <div class="row">
      <div class="col-12 row">
         <div class="w-auto mx-auto">
            <app-button-url
               [url]="'http://www.gob.mx/cms/uploads/attachment/file/55286/4._Ap_ndice_C_Diagn_stico_de_autoevaluaci_n.pdf'"
               [title]="'Diagnóstico de autoevaluación'"
               [icon]="'description'">
            </app-button-url>
         </div>
      </div>
   </div>
   <br>
   Ejemplo de formato de cédula de auditoría interna 
   <br><br>
   Ejemplo de plan de auditoría. 
   `,
   subContents: [
   ]
});